import { createHostModule } from '@wix/sdk-runtime/host-modules';
export const localRuntime = createHostModule({
    clear: ({ channel }) => function clear(...args) {
        return channel.invoke({
            namespace: 'storage',
            method: 'local.clear',
            args,
        });
    },
    getItem: ({ channel }) => function getItem(...args) {
        return channel.invoke({
            namespace: 'storage',
            method: 'local.getItem',
            args,
        });
    },
    removeItem: ({ channel }) => function removeItem(...args) {
        return channel.invoke({
            namespace: 'storage',
            method: 'local.removeItem',
            args,
        });
    },
    setItem: ({ channel }) => function setItem(...args) {
        return channel.invoke({
            namespace: 'storage',
            method: 'local.setItem',
            args,
        });
    },
});
//# sourceMappingURL=local.runtime.js.map